import { createFileRoute, Link, useLocation } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { LabPageHeader, LabSection } from '@/components/lab/LabBlocks'
import {
  EngineeringCta,
  PassageList,
} from '@/components/engineering/EngineeringPages'
import { getLocaleFromPath, withLocalePath } from '@/lib/i18n-utils'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/about')({
  head: ({ params }) => localizedPageHead('about', params.locale),
  component: AboutPage,
})

function AboutPage() {
  const { t } = useTranslation('lab')
  const locale = getLocaleFromPath(useLocation().pathname)
  const principles = t('site.company.principles', {
    returnObjects: true,
  }) as unknown as { title: string; body: string }[]
  return (
    <div className="min-h-screen engineering-page">
      <LabPageHeader
        eyebrow={t('about.eyebrow')}
        title={t('about.title')}
        intro={t('about.p1')}
      />
      <LabSection title={t('about.companyTitle')}>
        <p>{t('about.p2')}</p>
        <p className="font-mono text-sm">{t('about.company')}</p>
      </LabSection>
      <LabSection title={t('site.company.title')}>
        <p>{t('site.company.body')}</p>
        <Link to={withLocalePath('/products', locale)} className="journal-link">
          {t('site.labels.products')}
        </Link>
      </LabSection>
      <LabSection title={t('site.labels.approach')}>
        <PassageList items={principles} />
      </LabSection>
      <LabSection title={t('about.peopleTitle')}>
        <ul className="divide-y divide-border">
          {(['hamza', 'ahmet'] as const).map((k) => (
            <li
              key={k}
              className="flex flex-col py-3 sm:flex-row sm:justify-between"
            >
              <span className="text-foreground">{t(`about.${k}.name`)}</span>
              <span>{t(`about.${k}.role`)}</span>
            </li>
          ))}
        </ul>
      </LabSection>
      <EngineeringCta />
    </div>
  )
}
